import debug from 'debug';

const log = debug('app:videoUtils');

const downloadVideo = (url: string, name: string) => {
  try {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = name;
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    log(error);
  }
};

// Function to handle multiple downloads with delays to avoid browser blocking
const downloadMultipleVideos = (
  downloads: Array<{ url: string; name: string }>
) => {
  console.log(
    `Starting download of ${downloads.length} files:`,
    downloads.map((d) => d.name)
  );

  downloads.forEach(({ url, name }, index) => {
    setTimeout(() => {
      console.log(`Downloading file ${index + 1}/${downloads.length}: ${name}`);
      downloadVideo(url, name);
    }, index * 500); // Stagger downloads by 500ms each
  });
};

export { downloadVideo, downloadMultipleVideos };
export default downloadVideo;
